module.exports = __webpack_public_path__ + "static/media/aboutus.e41f6192.jpeg";